import {commitExposureTime} from "@/apis/recorded";

export default function exposure(): { addExposureMonitor: (element: Element) => void } {

  const observer = new IntersectionObserver((changes) => {
    changes.forEach((change) => {
      if (change.intersectionRatio > 0.5) {
        const courseId = Number(change.target.getAttribute('data-course-id'));
        const partId = Number(change.target.getAttribute('data-part-id'));
        const pageId = Number(change.target.getAttribute('data-page-id'));
        const exposureTime = change.target.getAttribute('data-exposure-time');
        if (partId > 0 && pageId > 0 && !exposureTime) {
          const now = new Date();
          commitExposureTime({
            courseId,
            partId,
            pageId,
            exposureTime: now
          }).then(res => {
            change.target.setAttribute('data-exposure-time', '' + now.getTime())
            if (res?.code == 200 && res?.data) {
              observer.unobserve(change.target)
            } else {
              console.error(`提交曝光时间失败, partId=${partId},partId=${pageId} `)
            }
          })
        }
      }
    })
  }, {
    threshold: 0.5
  });

  /**
   * 添加曝光监控
   * @param element
   */
  const addExposureMonitor = (element: Element) => {
    observer.observe(element)
  }
  return {
    addExposureMonitor
  }
}
